import { render, staticRenderFns } from "./ClaimTypeSetupEdit.vue?vue&type=template&id=7735b7c8"
import script from "./ClaimTypeSetupEdit.vue?vue&type=script&lang=js"
export * from "./ClaimTypeSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports